import { Injectable } from "@angular/core";
import { ChatSettingVoData, EncryptStorage } from "../..";
import { StorageData } from "../../storage/storage-data";
import { Events } from "ionic-angular";
var ConversationsSettingsModel = /** @class */ (function () {
    function ConversationsSettingsModel(storage, events) {
        this.storage = storage;
        this.events = events;
        this._model = new ChatSettingVoData();
    }
    ConversationsSettingsModel.prototype.load = function () {
        var _this = this;
        this.storage.load("conversations-settings", false).then(function (res) {
            if (res != null && typeof res != 'string') {
                _this._model = res;
            }
            _this.events.publish(ConversationsSettingsEvent.LOADED);
        });
    };
    ConversationsSettingsModel.prototype.save = function (storageData) {
        storageData.key = "conversations-settings";
        storageData.item = this._model;
        storageData.encrypt = false;
        return this.storage.saveAs(storageData);
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "welcomeTitle", {
        get: function () {
            return this._model.welcomeTitle;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setWelcomeTitle = function (value, preventDefault) {
        this._model.welcomeTitle = value;
        return this.save(new StorageData(ConversationsSettingsEvent.WELCOME_TITLE, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "welcomeDescription", {
        get: function () {
            return this._model.welcomeDescription;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setWelcomeDescription = function (value, preventDefault) {
        this._model.welcomeDescription = value;
        return this.save(new StorageData(ConversationsSettingsEvent.WELCOME_DESCRIPTION, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "showWelcomeLogo", {
        get: function () {
            return this._model.showWelcomeLogo;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setShowWelcomeLogo = function (value, preventDefault) {
        this._model.showWelcomeLogo = value;
        return this.save(new StorageData(ConversationsSettingsEvent.SHOW_WELCOME_LOGO, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "welcomeLogoStyle", {
        get: function () {
            return this._model.welcomeLogoStyle;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setWelcomeLogoStyle = function (value, preventDefault) {
        this._model.welcomeLogoStyle = value;
        return this.save(new StorageData(ConversationsSettingsEvent.WELCOME_LOGO_STYLE, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "welcomeLogoUrl", {
        get: function () {
            return this._model.welcomeLogoUrl;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setWelcomeLogoUrl = function (value, preventDefault) {
        this._model.welcomeLogoUrl = value;
        return this.save(new StorageData(ConversationsSettingsEvent.WELCOME_LOGO_URL, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "liveSupportOnline", {
        get: function () {
            return this._model.liveSupportOnline;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setLiveSupportOnline = function (value, preventDefault) {
        this._model.liveSupportOnline = value;
        return this.save(new StorageData(ConversationsSettingsEvent.LIVE_SUPPORT_ONLINE, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "liveSupportProvided", {
        get: function () {
            return this._model.liveSupportProvided;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setLiveSupportProvided = function (value, preventDefault) {
        this._model.liveSupportProvided = value;
        return this.save(new StorageData(ConversationsSettingsEvent.LIVE_SUPPORT_PROVIDED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "workingHoursMessage", {
        get: function () {
            return this._model.workingHoursMessage;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setWorkingHoursMessage = function (value, preventDefault) {
        this._model.workingHoursMessage = value;
        return this.save(new StorageData(ConversationsSettingsEvent.WORKING_HOURS_MESSAGE_CHANGED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "notWorkingHoursGreetingMessage", {
        get: function () {
            return this._model.notWorkingHoursGreetingMessage;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setNotWorkingHoursGreetingMessage = function (value, preventDefault) {
        this._model.notWorkingHoursGreetingMessage = value;
        return this.save(new StorageData(ConversationsSettingsEvent.NOT_WORKING_HOURS_GREETING_MESSAGE_CHANGED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "notWorkingHoursMessage", {
        get: function () {
            return this._model.notWorkingHoursMessage;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setNotWorkingHoursMessage = function (value, preventDefault) {
        this._model.notWorkingHoursMessage = value;
        return this.save(new StorageData(ConversationsSettingsEvent.NOT_WORKING_HOURS_MESSAGE_CHANGED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "requestEmailMessage", {
        get: function () {
            return this._model.requestEmailMessage;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setRequestEmailMessage = function (value, preventDefault) {
        this._model.requestEmailMessage = value;
        return this.save(new StorageData(ConversationsSettingsEvent.REQUEST_EMAIL_MESSAGE, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "askEmailType", {
        get: function () {
            return this._model.askEmailType;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setAskEmailType = function (value, preventDefault) {
        this._model.askEmailType = value;
        return this.save(new StorageData(ConversationsSettingsEvent.ASK_EMAIL_TYPE_CHANGED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "userIds", {
        get: function () {
            return this._model.userIds;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setUserIds = function (value, preventDefault) {
        this._model.userIds = value;
        return this.save(new StorageData(ConversationsSettingsEvent.USER_IDS_CHANGED, preventDefault, value));
    };
    Object.defineProperty(ConversationsSettingsModel.prototype, "userTeamIds", {
        get: function () {
            return this._model.userTeamIds;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingsModel.prototype.setUserTeamIds = function (value, preventDefault) {
        this._model.userTeamIds = value;
        return this.save(new StorageData(ConversationsSettingsEvent.USER_TEAM_IDS_CHANGED, preventDefault, value));
    };
    ConversationsSettingsModel.prototype.clear = function (preventDefault, preventSave) {
        this._model.workingHoursMessage = null;
        this._model.liveSupportOnline = null;
        this._model.liveSupportProvided = null;
        this._model.notWorkingHoursMessage = null;
        this._model.requestEmailMessage = null;
        this._model.askEmailType = null;
        var storageData = new StorageData(ConversationsSettingsEvent.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    ConversationsSettingsModel.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConversationsSettingsModel.ctorParameters = function () { return [
        { type: EncryptStorage, },
        { type: Events, },
    ]; };
    return ConversationsSettingsModel;
}());
export { ConversationsSettingsModel };
export var ConversationsSettingsEvent;
(function (ConversationsSettingsEvent) {
    ConversationsSettingsEvent["LOADED"] = "conversations-settings:loaded";
    ConversationsSettingsEvent["WELCOME_TITLE"] = "conversations-settings-welcome-title:changed";
    ConversationsSettingsEvent["WELCOME_DESCRIPTION"] = "conversations-settings-welcome-description:changed";
    ConversationsSettingsEvent["SHOW_WELCOME_LOGO"] = "conversations-settings-show-welcome-logo:changed";
    ConversationsSettingsEvent["WELCOME_LOGO_STYLE"] = "conversations-settings-welcome-logo-style:changed";
    ConversationsSettingsEvent["WELCOME_LOGO_URL"] = "conversations-settings-welcome-logo-url:changed";
    ConversationsSettingsEvent["LIVE_SUPPORT_ONLINE"] = "live-support-online:changed";
    ConversationsSettingsEvent["LIVE_SUPPORT_PROVIDED"] = "live-support-provided:changed";
    ConversationsSettingsEvent["WORKING_HOURS_MESSAGE_CHANGED"] = "conversations-settings-working-hours-message:changed";
    ConversationsSettingsEvent["NOT_WORKING_HOURS_GREETING_MESSAGE_CHANGED"] = "conversations-settings-not-working-hours-greeting-message:changed";
    ConversationsSettingsEvent["NOT_WORKING_HOURS_MESSAGE_CHANGED"] = "conversations-settings-not-working-hours-message:changed";
    ConversationsSettingsEvent["REQUEST_EMAIL_MESSAGE"] = "conversations-settings-request-email-message:changed";
    ConversationsSettingsEvent["ASK_EMAIL_TYPE_CHANGED"] = "conversations-settings-ask-email-type:changed";
    ConversationsSettingsEvent["USER_IDS_CHANGED"] = "conversations-user-ids:changed";
    ConversationsSettingsEvent["USER_TEAM_IDS_CHANGED"] = "conversations-user-team-ids:changed";
    ConversationsSettingsEvent["CLEARED"] = "conversations-settings:cleared";
})(ConversationsSettingsEvent || (ConversationsSettingsEvent = {}));
//# sourceMappingURL=conversations-settings-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/chat/conversations-settings-model.js
// module id = 150
// module chunks = 14